<template>
    <reconciliation-step-template
        :nextStep="false"
        :previousStep="false"
        @previous="$emit('previous')"
        :loading="loading"
    >
        <template #header> &nbsp; </template>
        <template #content>
            <div class="wp-6 m-auto acenter">
                <i class="icon-email-statut-valid success-50 fs-131"></i>
                <p class="fs-4 semibold mt-6">
                    {{
                        $l10n.__(
                            'Votre fichier a été correctement configuré, il sera disponible dans quelques instants sur votre outil de rapprochement bancaire.',
                        )
                    }}
                </p>
                <CompassButton
                    :label="$t.__('common.actions.continue')"
                    type="primary"
                    @click="next"
                    class="mt-3"
                />
            </div>
        </template>
        <template #footer> &nbsp; </template>
    </reconciliation-step-template>
</template>

<script>
import ReconciliationStepTemplate from './ReconciliationStepTemplate.vue';
export default {
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        next() {
            window.location.href = '/?_f=bankreconciliation_transactions';
        },
    },
    computed: {
        idImport() {
            return this.$route.params.importid;
        },
    },
    components: {
        ReconciliationStepTemplate,
    },
};
</script>

<style scoped>
.fs-131 {
    font-size: 131px;
}
</style>
